import { API_CALL } from 'actions/actionConstants'
import { AppAction } from 'actions/types/ActionTypes'
import { FETCH_LOYALTY_CONFIG } from 'actions/apiActionConstants'
import requestLoyaltyConfig from 'api/loyalty/requestLoyaltyConfig'

function fetchLoyaltyConfig(): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    if (
      state.loyalty.config ||
      state.loyalty.fetchingConfig ||
      state.loyalty.configError
    ) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_LOYALTY_CONFIG,
      request: () => requestLoyaltyConfig(state.geo.currentRegionCode),
    })
  }
}

export default fetchLoyaltyConfig
